module.exports = __webpack_public_path__ + "tn.c17b985c.svg";